<template>
    <calculator-form
        ref="form"
        :title="title"
    >
        <template slot="form">
            <v-layout
                wrap
            >
                <v-flex
                    xs12
                    sm6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        v-model="client.employee_number"
                        label="Government Employee Number"
                        type="text"
                        filled
                        v-facade="'####-####'"
                        :rules="[
                            v => !!v || 'Government Employee Number is required',
                            v => v.length === 9 || 'Government Employee Number needs to be 8 digits long',
                        ]"
                        :disabled="checking"
                    ></v-text-field>
                </v-flex>
                <v-flex
                    xs12
                    sm6
                >
                    <v-autocomplete
                        class="title-branding custom-select"
                        :items="types"
                        :filter="typeFilter"
                        v-model="client.type"
                        item-text="label"
                        item-value="id"
                        filled
                        label="Payroll"
                        :rules="[
                            v => !!v || 'Payroll is required'
                        ]"
                        :disabled="checking"
                    ></v-autocomplete>
                </v-flex>
                <v-flex
                    xs12
                >
                    <v-autocomplete
                        class="title-branding custom-select"
                        v-model="client.department"
                        :items="departments"
                        :filter="typeFilter"
                        item-text="label"
                        item-value="id"
                        filled
                        label="Government Department"
                        :rules="[
                            v => !!v || 'Government Department is required'
                        ]"
                        :disabled="checking"
                    ></v-autocomplete>
                </v-flex>
            </v-layout>
        </template>
        <template slot="actions">
            <v-card-actions
                v-if="kpError"
            >
                <v-alert
                    type="error"
                    icon="$mdiAlert"
                    class="w-full title-branding caption"
                >
                    {{ kpError }}
                </v-alert>
            </v-card-actions>
            <v-card-actions
                v-if="hasResponse"
                class="pb-0"
            >
                <v-alert
                    :type="alertColor"
                    :icon="alertIcon"
                    class="w-full title-branding caption"
                >
                    {{ alertMessage }}
                </v-alert>
            </v-card-actions>
            <v-card-actions
                :class="isMobile ? 'justify-space-between' : ''"
            >
                <v-btn
                    class="custom-button"
                    type="button"
                    :color="$vuetify.theme.dark ? 'primary lighten-1' : 'primary'"
                    :disabled="checking"
                    @click="goBack"
                    :small="isMobile"
                >
                    <v-icon
                        dark
                        small
                    >
                        $mdiChevronLeft
                    </v-icon>
                    Back
                </v-btn>
                <v-btn
                    color="grey"
                    type="button"
                    :disabled="checking"
                    class="primary--text custom-button"
                    @click="newQuote"
                    :small="isMobile"
                >
                    New quote
                </v-btn>
                <v-spacer v-if="!isMobile"></v-spacer>
                <v-btn
                    class="custom-button"
                    type="button"
                    color="accent"
                    :loading="checking"
                    @click="validate"
                    :small="isMobile"
                >
                    Verify
                </v-btn>
            </v-card-actions>
        </template>
    </calculator-form>
</template>
<script>
import CalculatorForm from './../../Global/Form';

import KeyPlanMixin from "./../keyplan";

export default {
    name: "KeyPlan-Step-Two",

    mixins: [
        KeyPlanMixin
    ],

    components: {
        CalculatorForm,
    },

    props: {
        'title': {
            type: String,
            default: ''
        }
    },

    data() {
        return {}
    },

    mounted() {
    },

    computed: {
        hasResponse() {
            return typeof this.affordability.pass !== 'undefined';
        },
        alertColor() {
            return typeof this.affordability.pass !== 'undefined' && this.affordability.pass ? 'success' : 'error';
        },
        alertIcon() {
            return typeof this.affordability.pass !== 'undefined' && this.affordability.pass ? '$mdiCheckCircle' : '$mdiAlert';
        },
        alertMessage() {
            let message = 'Client is approved for plan!';

            if (typeof this.affordability.response !== 'undefined' && typeof this.affordability.response.err_message !== 'undefined' && this.affordability.response.err_message !== '') {
                message = this.affordability.response.err_message
            }

            return message;
        },
    },

    methods: {
        typeFilter(item, queryText, itemText) {
            const textOne = item.label.toLowerCase();
            const searchText = queryText.toLowerCase();

            return textOne.indexOf(searchText) > -1;
        },
        goBack() {
            this.$store.commit('calculators/setCurrentStep', 1);
        },
        newQuote() {
            this.$store.dispatch('keyplan/newQuote');
        },
        validate() {
            this.$refs.form.validateForm()
                .then((response) => {
                    if (!this.formIsValid) {
                        return;
                    }

                    this.$store.dispatch('keyplan/getAffordability');
                });
        },
    }
}
</script>
